module.exports = __webpack_public_path__ + "img/games.1b0675c9.svg";